<template>
    <div>
        <!-- Chamada de Voz -->
        <p v-if="!suportado">Chamada de voz não suportada nesse dispostivo.</p>
    </div>
</template>

<script>
import Speech from 'speak-tts'

export default {
    data() { 
        return { 
            suportado: false,
            speech: null,
            texto: "Maria da Silva, Guichê 4", 
            voices: [],
        }
    },

    watch: { 
        selvoz: function (val) { 
            if (val) { 
                this.speech.setVoice(val);
                this.falar('Olá, essa é a voz de ' + val + '.');
            }
        }
    },

    props: ['selvoz'], 

    methods: { 
        falar(texto) { 
            console.log('Falar!');

            this.speech.speak({
                text: texto,
            }).then(() => {
                console.log("Success !")
            }).catch(e => {
                console.error("An error occurred :", e)
            })
        },

        getVoices() { 
            return this.voices;
        }
    },

    mounted() { 
        this.speech = new Speech() // will throw an exception if not browser supported
        if(this.speech.hasBrowserSupport()) { // returns a boolean

            let params = {
                'volume': 1,
                'lang': 'pt-BR',
                'rate': 1,
                'pitch': 1,
                'splitSentences': true,
                'listeners': {
                    'onvoiceschanged': (voices) => {
                        this.voices = voices 
                            ? voices.filter(item => item.lang == 'pt-BR')
                                .map(item => { 
                                    return { 
                                        id: item.name, 
                                        search: item.name,
                                        // voice: item 
                                    };
                                })
                                .sort() 
                            : [];
                        console.log("Event voiceschanged", voices)
                    }
                }
            };
            
            console.log("speech synthesis supported")
            this.suportado = true;

            this.speech = new Speech()
            this.speech.init(params).then((data) => {
                // The "data" object contains the list of available voices and the voice synthesis params
                console.log("Speech is ready, voices are available", data)
            }).catch(e => {
                console.error("An error occured while initializing : ", e)
            })

        } else { 

            console.log("speech synthesis not supported")

        }
    }
}
</script>